import * as React from 'react';
import { IOffice } from '../../store/pik_data/offices';
import { Map } from '../Map';
import { getRegionCenter, Region } from '../../utils/regions';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';

const styles = require('./offices.css');

interface IOfficesProps {
  offices: IOffice[];
  region: Region;
}

export class OfficesComponent extends React.PureComponent<IOfficesProps, object> {
  public render() {
    return (
      <div className={styles['offices']}>
        <Map mapId="offices-map" pins={this.props.offices} initialCenter={getRegionCenter(this.props.region)} />
      </div>
    );
  }
}

const getOfficesWithRooms = (state: IApplicationState) => {
  const offices = (state.offices || []).filter(office => office.locationId === state.filter.query.region);
  const gks = state.gks;

  return offices.map(office => {
    const gk = gks?.find(gk => gk.title === office.title);

    return { ...office, rooms: (gk && gk.rooms) || [] };
  });
};

export const Offices = connect((state: IApplicationState) => ({
  offices: getOfficesWithRooms(state),
  region: state.filter.query.region,
}))(OfficesComponent);
